<template>
  <div class="set-page">
    <h1 class="user-center-h1">設定</h1>
    <Tabs
      v-model="activePath"
      class="link-wrap"
      :options="linkList"
      @change="changePath"
    />
    <div >
    </div>
    <router-view/>
  </div>
</template>
<script>
import Tabs from '@/components/Tabs'
export default {
  name: 'UserSet',
  components: {
    Tabs,
  },
  data() {
    const linkList = [
      {
        label: '帳戶與安全',
        value: '/user-set/account',
      },
      {
        label: '黑名單',
        value: '/user-set/black',
      },
      {
        label: '通知',
        value: '/user-set/notice',
      },
    ]
    return {
      activePath: this.$route.path,
      linkList,
    }
  },
  created() {

  },
  methods: {
    changePath(path) {
      this.$router.replace({
        path
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .set-page {
    padding-bottom: 64px !important;
    overflow-y: auto;
    .link-wrap {
      margin-bottom: 28px;
    }
  }
</style>
